import React, { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';
import Colors from './assets/style/Colors';
import { ToasterContainer } from './components/toaster/Toaster';
import AuthRoutes from './routes/AuthRoutes';
import DashboardRoutes from './routes/DashboardRoutes';
import devtoolsDetect from 'devtools-detect';
import ScrollToTop from './hooks/ScrollToTop';
import { useAuth } from 'context/UseContext';
import "@fontsource/poppins";

function App() {

  const { user } = useAuth();

  const theme = createTheme({
    palette: {
      primary: {
        main: Colors.primary,
        contrastText: Colors.white,
      },
      secondary: {
        main: Colors.secondary,
        contrastText: Colors.white,
      },
      danger: {
        main: Colors.danger,
        contrastText: Colors.white,
      },
    },
    typography: {
      fontFamily: "Poppins",
      h3: {
        fontSize: 28,
        fontWeight: 700,
      },
      h5: {
        fontSize: 24,
        fontWeight: 700,
      },
      h6: {
        fontSize: 22,
        fontWeight: 700,
      },
      subtitle1: {
        fontSize: 20,
        fontWeight: 600,
      },
      subtitle2: {
        fontSize: 18,
        fontWeight: 500
      },
      body1: {
        fontSize: 16,
        fontWeight: 500
      },
      body2: {
        fontSize: 14,
        fontWeight: 400
      },
      caption: {
        fontSize: 12,
        fontWeight: 300
      },
    },
  });
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(devtoolsDetect.isOpen);
    // useEffect(() => {
    //   const checkDevTools = () => {
    //     if (devtoolsDetect.isOpen) {
    //       setIsDevToolsOpen(true);
    //       window.location.href = "https://www.google.com";
    //     }
    //   };

    //   // Har 1 second baad check karega
    //   const interval = setInterval(checkDevTools, 1000);

    //   const handleContextMenu = (e) => e.preventDefault();
    //   const handleKeyDown = (e) => {
    //     if (
    //       e.keyCode === 123 || // F12
    //       (e.ctrlKey && e.shiftKey && e.keyCode === 73) || 
    //       (e.ctrlKey && e.shiftKey && e.keyCode === 74) || 
    //       (e.ctrlKey && e.keyCode === 85)
    //     ) {
    //       e.preventDefault();
    //     }
    //   };

    //   document.addEventListener("contextmenu", handleContextMenu);
    //   document.addEventListener("keydown", handleKeyDown);

    //   return () => {
    //     clearInterval(interval);
    //     document.removeEventListener("contextmenu", handleContextMenu);
    //     document.removeEventListener("keydown", handleKeyDown);
    //   };
    // }, []);
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>

        {/* ========== Toaster ========== */}
        <ToasterContainer />

        <Routes>

          <Route element={user?.access_token ? <Navigate to="/" /> : <Outlet />} >
            {AuthRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={route.component}
              />
            ))}
          </Route>

          <Route element={user?.access_token ? <Outlet /> : <Navigate to="/login" />} >
            {DashboardRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={route.component}
              />
            ))}
          </Route>

        </Routes>

        {/* ========== Scroll To Top ========== */}
        <ScrollToTop />

      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
